import React, { useEffect, useState } from 'react'

import RichText from '../../../react4xp/components/RichText'
import Image from '../../../react4xp/components/Image'
import Section from '../../../react4xp/components/Section'
import Mask from '../../../react4xp/components/Mask'
import Form from '../../../react4xp/components/Form/Form'
import Input from '../../../react4xp/components/Form/Input'
import Button from '../../../react4xp/components/Button'
import Fancybox from '../../../react4xp/components/Fancybox'
import MasonryGrid from '../../../react4xp/components/MasonryGrid'
import TextArea from '../../../react4xp/components/Form/TextArea'
import Link from '../../../react4xp/components/Link'
import Stars from '../../../react4xp/components/Stars'
import Balloon from '../../../react4xp/components/Balloon'
import Video from '../../../react4xp/components/Video'

import { Region } from '@enonic/react-components';
import { GeneralChat, GeneralClock, GeneralClose, GeneralLink, GeneralStar } from '../../../react4xp/components/Svg/Icons/General'
import { UxAngleDown } from '../../../react4xp/components/Svg/Ux/Angle'
import {EmojiHappy} from '../../../react4xp/components/Svg/Icons/Emoji'

import clsx from 'clsx'
import dayjs from 'dayjs'
import 'dayjs/locale/nb'

function RecipeLayout({
	isLogged,
	recipeId,
	title,
	intro,
	rating,
	totalRatings,
	totalRatingsNumber,
	totalComments,
	image,
	video,
	textLabel,
	instructions,
	tips,
	time,
	portions,
	ingredients,
	allergens,
	tracesOf,
	reviewsSection,
	regions,
	strings,
}) {
	// reviews
	const [reviews, setReviews] = useState<any[]>([])
    const [page, setPage] = useState(reviewsSection.page || 1)
    const [hasNextPage, setHasNextPage] = useState(false)
    const [loadMore, setLoadMore] = useState(false)
    const [ratingValue, setRatingValue] = useState(rating)
	const [totalReviewsState, setTotalReviewsState] = useState(totalRatingsNumber)

	// toogle details blocks
	const [isIngredientsActive, setIsIngredientsActive] = useState(false)
	const [isStepsActive, setIsStepsActive] = useState(false)
	const [isAllergensActive, setIsAllergensActive] = useState(false)
	const [isTipsActive, setIsTipsActive] = useState(false)
	const [lastWidth, setLastWidth]: any = useState(null)
	
	useEffect(() => {
		const checkWindowWidth = () => {
			const currentWidth = window.innerWidth

			if (currentWidth !== lastWidth) {
				setLastWidth(currentWidth)
				const isWideScreen = currentWidth >= 768

				setIsIngredientsActive(isWideScreen)
				setIsStepsActive(isWideScreen)
				setIsAllergensActive(isWideScreen)
				setIsTipsActive(isWideScreen)
			}
		}

		checkWindowWidth()

		window.addEventListener('resize', checkWindowWidth)

		return () => {
			window.removeEventListener('resize', checkWindowWidth)
		}
	}, [lastWidth])

	useEffect(() => {
		handleFetchComments()
    }, [page])

    const handleFetchComments = async () => {

        if (!reviewsSection.reviewsEndpoint) return;

        const url = new URL(reviewsSection.reviewsEndpoint);
        const queryParams = new URLSearchParams();

        if (page) queryParams.append('page', String(page));
        if (reviewsSection.pageSize) queryParams.append('pageSize', reviewsSection.pageSize);
        queryParams.append('contentId', recipeId);

        url.search = queryParams.toString();

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            const data = await response.json();

            if (loadMore) {
                setReviews([...reviews, ...data.hits]);
                setLoadMore(false)
            } else {
                setReviews(data.hits);
            }

            setHasNextPage(data.hasNextPage);

        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }

    const handleLoadMoreComments = () => {
        if (hasNextPage) {
            setLoadMore(true)
            setPage(page + 1)
        }
    }

	const toggleIngredients = () => { setIsIngredientsActive((prev) => !prev) }

	const toggleSteps = () => { setIsStepsActive((prev) => !prev) }
	
	const toggleAllergens = () => { setIsAllergensActive((prev) => !prev) }
	
	const toggleTips = () => { setIsTipsActive((prev) => !prev) }

	const [fancyEventInit, setFancyEventInit] = useState(false)

	// copy url
	const [showTooltip, setShowTooltip] = useState(false)
	
	const copyToClipboard = () => {
		navigator.clipboard.writeText(location.href)
		setShowTooltip(true)
    	setTimeout(() => setShowTooltip(false), 3000)
	}

	const smoothScroll = (e) => {
		e.preventDefault()
		const linkElement = e.target.closest('a')
	  
		if (linkElement) {
			const aid = linkElement.getAttribute('href')
			const targetElement = document.querySelector(aid)
		
			if (targetElement) {
				targetElement.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				})
			}
		}
	}

	// update tabindex based on the window width
	const [tabIndex, setTabIndex]: any = useState(null)

	useEffect(() => {
		const updateTabIndex = () => {
			if (window.innerWidth >= 768) {
				setTabIndex(-1)
			} else {
				setTabIndex(null)
			}
		}

		updateTabIndex()

		window.addEventListener('resize', updateTabIndex)

		return () => window.removeEventListener('resize', updateTabIndex)
	}, [])

    return (
		<div className='page-recipe'>

		<Section
			className='page-recipe__header'
			paddingTop='small'
			paddingBottom='none'
		>
			<div className='container'>

				{image && (
					<div className='header-image'>
						<Mask>
							<Image
								src={image?.src}
								srcMedium={image?.srcMedium}
								width={1300}
								alt={image?.alt}
								className='cover'
							/>
						</Mask>
					</div>
				)}

				<div className='header-content'>
					<div className='row'>
						<div className='col-sm-10 offset-sm-1 col-md-8 offset-md-2'>
							<Mask bgColor='white' spacing='small' className='box'>

								{title && (
									<h1 className='h1-hero-small'>
										{title}
									</h1>
								)}

								<div className='top-tags'>

									{textLabel && (
										<div className='difficulty'>
											<Balloon
												arrow='bottom-middle'
												arrowSide='left'
												arrowSize='small'
												balloonColor='blue'
												balloonSide='right'
												spacing='smaller'
												className='text-smaller medium'
											>
												{textLabel}
											</Balloon>
										</div>
									)}

									{time && (
										<div className='time'>
											<GeneralClock variant='outline' />
											<p className='text-small'>
												{time}
											</p>
										</div>
									)}

								</div>

								{intro && (
									<div className='desc'>
										<RichText
											content={intro}
										/>
									</div>
								)}

								<div className='bottom-tags'>

									<a
										href='#reviews'
										className='rating'
										onClick={smoothScroll}
									>

										<Stars howMany={ratingValue} />
										
										<p className='text-small'>
											{`${totalReviewsState} ${(totalReviewsState > 1) ? strings.unitRatingPlural : strings.unitRatingSingular }`}
										</p>

									</a>

									<div className='comments'>

										<GeneralChat />

										<p className='text-small'>
											{totalComments}
										</p>

									</div>

								</div>

								<div className='link'>
									<Link
										data-tooltip={strings.linkCopied}
										onClick={copyToClipboard}
										text={strings.copyLink}
										icon={<GeneralLink variant='outline' />}
										iconPosition='left'
										className={showTooltip ? 'tooltip-visible' : ''}
									/>
								</div>

							</Mask>
						</div>
					</div>
				</div>

			</div>
		</Section>

		<Section
			bgColor='white'
			className='page-recipe__details'
			paddingTop='small'
			paddingBottom='small'
		>
			<div className='container'>
				<div className='row'>

					{ingredients.length > 0 && (
						<div className='col-md-6 col-lg-5 left'>
							<Mask bgColor='yoghurt' spacing='smaller'>
								<div className={clsx(
									'accordion',
									isIngredientsActive && 'is-active'
								)}>

									<button
										type='button'
										className='accordion__title'
										onClick={toggleIngredients}
										tabIndex={tabIndex}
									>

										<h3 className='products-box__title h5'>
											{strings.ingredientsHeader}
										</h3>

										<UxAngleDown />

									</button>

									<div className='accordion__content'>
										<div>

											<p>
												{portions}
											</p>

											<div className='tags text-small'>

												{ingredients.map((item, i) => (
													<Mask bgColor='white' key={i}>
														<p>
															{item}
														</p>
													</Mask>
												))}

											</div>
										</div>
									</div>

								</div>
							</Mask>
						</div>
					)}

					<div className='col-md-6 col-lg-7 right'>

						{instructions && (
							<Mask bgColor='yoghurt' spacing='smaller'>
								<div className={clsx(
									'accordion',
									isStepsActive && 'is-active'
								)}>

									<button
										type='button'
										className='accordion__title'
										onClick={toggleSteps}
										tabIndex={tabIndex}
									>

										<h3 className='products-box__title h5'>
											{strings.instructionsHeader}
										</h3>

										<UxAngleDown />

									</button>

									<div className='accordion__content'>
										<div>
											<RichText
												content={instructions}
											/>
										</div>
									</div>

								</div>
							</Mask>
						)}

						{((allergens.length > 0) || (tracesOf.length > 0)) && (
							<Mask bgColor='yoghurt' spacing='smaller' className='expand'>
								<div className={clsx(
									'accordion',
									isAllergensActive && 'is-active'
								)}>

									<button
										type='button'
										className='accordion__title'
										onClick={toggleAllergens}
										tabIndex={tabIndex}
									>

										<h3 className='products-box__title h5'>
											{strings.allergensHeader}
										</h3>

										<UxAngleDown />

									</button>

									<div className='accordion__content'>
										<div>
											{
												(allergens.length > 0) &&
												<div className='tags text-small'>
													{ allergens.map((allergen, i) =>
														<Mask bgColor='white' key={i}>
															{allergen.icon && <span dangerouslySetInnerHTML={{ __html: allergen.icon }}></span>}
															<p>{allergen.title}</p>
														</Mask>
													)}
												</div>
											}

											{
												(tracesOf.length > 0) &&
												<>
													<div className='accordion__title'>
														<h3 className='products-box__title h4'>
															{strings.tracesOfHeader}
														</h3>
													</div>

													<div className='tags text-small'>
														{ tracesOf.map((allergen, i) =>
															<Mask bgColor='white' key={i}>
																{allergen.icon && <span dangerouslySetInnerHTML={{ __html: allergen.icon }}></span>}
																<p>{allergen.title}</p>
															</Mask>
														)}
													</div>
												</>
											}
										</div>
									</div>

								</div>
							</Mask>
						)}

						{tips && (
							<Mask bgColor='#83C146' spacing='smaller'>
								<div className={clsx(
									'accordion',
									isTipsActive && 'is-active'
								)}>

									<button
										type='button'
										className='accordion__title'
										onClick={toggleTips}
										tabIndex={tabIndex}
									>

										<h3 className='products-box__title h5'>
											{strings.tipsHeader}
										</h3>

										<UxAngleDown />

									</button>

									<div className='accordion__content'>
										<div>
											<RichText
												content={tips}
											/>
										</div>
									</div>

								</div>
							</Mask>
						)}

					</div>

				</div>
			</div>
		</Section>

		{video && (
			<Section bgColor='white' className='page-recipe__video'>
				<div className='container'>
					<Mask bgColor='yoghurt' spacing='small'>

						<h2 className='h3'>
							{strings.videoTutorial}
						</h2>

						<div className='video-outer-wrapper'>
							<Mask maskDistortion='low'>
								<Video
									video={{
										url: video.url,
										videoType: video.videoType,
										playButtonColor: 'blue',
										playTextColor: 'white',
										playText: strings.videoPlayText,
										poster: video.poster,
										posterMedium: video.posterMedium,
										cookieConsentHtml: video.cookieConsentHtml,
									}}
									className='cover'
								/>
							</Mask>
						</div>
					</Mask>
				</div>
			</Section>

		)}

		<Region name={regions.region1.name} regionData={regions.region1} />

		<Section bgColor='yoghurt' className='page-recipe__reviews' id='reviews'>
			<div className='container'>

				<div className='page-recipe__reviews__top'>
					<div className='row'>
						<div className='col-md-9 col-lg-7 col-xl-6'>

							<h2 className='title-top h3'>
								{strings.reviewsHeader}
							</h2>

							<Fancybox
                                    options={{
                                        autoFocus: false,
                                        dragToClose: false,
                                        on: {
											close: () => {
                                                setFancyEventInit(true)
                                            },
                                            done: (_fancybox, slide) => {
												const _fancyboxParam = _fancybox
                                                function hideErrorMessage() {
                                                    const errorMessage = modal?.querySelector('.error-message')
                                                    if (errorMessage) {
                                                        errorMessage.remove()
                                                    }
                                                }
                                                function showErrorMessage(message) {
                                                    const errorMessage = modal?.querySelector('.error-message')

                                                    if (errorMessage) hideErrorMessage()

                                                    const newErrorMessage = document.createElement('p')
                                                    newErrorMessage.classList.add('error-message', 'red', 'text-smaller')
                                                    newErrorMessage.innerText = message
                                                    modal?.querySelector('.popup__content')?.appendChild(newErrorMessage)
                                                }
                                                function closeModal() {
                                                    const ratingInputs = modal?.querySelectorAll('input[name="rating"]') as NodeListOf<HTMLInputElement>

                                                    modal?.classList?.remove('is-sending')

                                                    ratingInputs.forEach(input => {
                                                        input.checked = false
                                                    })

                                                    _fancyboxParam.close()
                                                }

                                                const modal = document.getElementById('rating-modal')
                                                const confirmVote = modal?.querySelector('.confirm-vote')
                                                let selectedRating: any = null

                                                if (confirmVote && !fancyEventInit) {
                                                    confirmVote.addEventListener('click', function () {
                                                        const ratingInputs = modal?.querySelectorAll('input[name="rating"]') as NodeListOf<HTMLInputElement>

                                                        selectedRating = Array.from(ratingInputs).find(input => input.checked)

                                                        if (!selectedRating) {
                                                            showErrorMessage(strings.rateRecipeEmptyError)
                                                        } else {
                                                            modal?.classList?.add('is-sending')
                                                            fetch(reviewsSection.rateEndpoint, {
                                                                method: 'post',
                                                                body: JSON.stringify({
                                                                    contentId: recipeId,
                                                                    stars: selectedRating?.value
                                                                })
                                                            })
                                                                .then(response => {
                                                                    if (response.ok) {
                                                                        return response.json()
                                                                    } else {
                                                                        throw Error('Error')
                                                                    }
                                                                })
                                                                // if success
                                                                .then((responseData) => {
                                                                    hideErrorMessage()
                                                                    setTotalReviewsState(responseData.totalRating)
                                                                    setRatingValue(responseData.rating)
                                                                    closeModal()
                                                                })
                                                                // if error
                                                                .catch(error => {
                                                                    modal?.classList?.remove('is-sending')
                                                                    showErrorMessage(strings.rateRecipeGeneralError)
                                                                })
                                                        }
                                                    })
                                                }
                                            }
                                        }
                                    }}
                                >

                                    <a
                                        href='#rating-modal'
                                        data-fancybox
										className='rating-button'
                                    >

                                        <Stars howMany={ratingValue || 0} />

                                        <span>
                                            {totalReviewsState} {strings.reviewsCount}
                                        </span>

                                    </a>

                                    <Mask id='rating-modal' className='popup popup--small'>
                                        <div className='popup__wrapper'>
                                            <div className='popup__close'>
                                                <button
                                                    className='popup__close-button link-w-icon link-w-icon--icon-right text-smaller'
                                                    type='button'
                                                    data-fancybox-close
                                                >
                                                    <span>
                                                        {strings.modalClose}
                                                    </span>
                                                    <GeneralClose variant='outline' />
                                                </button>
                                            </div>

                                            <div className='popup__content'>

                                                <div className='rating-stars'>

                                                    {[5, 4, 3, 2, 1].map((stars) => (
                                                        <React.Fragment key={stars}>

                                                            <input
                                                                type='radio'
                                                                name='rating'
                                                                value={stars}
                                                                id={`rating-${stars}`}
                                                            />

                                                            <label htmlFor={`rating-${stars}`}>
                                                                <GeneralStar variant='white' />
                                                            </label>

                                                        </React.Fragment>
                                                    ))}

                                                </div>

                                                <Button
                                                    className='confirm-vote'
                                                    type='submit'
                                                    hasBorders
                                                    hover='blue-dark'
                                                    noUnderline
                                                >
                                                    {strings.rateRecipeSubmit}
                                                </Button>

                                            </div>

                                        </div>
                                    </Mask>

                                </Fancybox>

						</div>
					</div>
				</div>

				<div className='page-recipe__reviews__grid'>
					<MasonryGrid
						items={reviews}
						columnGutter={20}
						maxColumnCount={2}
						columnWidth={325}
						breakpointCols={{
							default: 2,
							767: 1
						}}
						className='reviews-grid'
						render={({ data }) => (
							<Mask
								bgColor='white'
								spacing='smaller'
							>
								
								<h3 className='h5 review-title'>
									{data.title}
								</h3>

								<div className='review-content'>
									<RichText content={data.content} />
								</div>

								<div className='review-bottom'>

									<EmojiHappy variant='outline' />

									<p className='text-smaller'>
										{data.name ? `${data.name}, ` : ''}{dayjs(data.date).format('D. MMM. YYYY')}
									</p>

								</div>

							</Mask>
						)}
					/>
				</div>

				<div className='page-recipe__reviews__bottom'>

					{hasNextPage && (
						<div className='load-more'>
							<Link
								text={strings.loadMoreReviews}
								onClick={handleLoadMoreComments}
								iconPosition='right'
								icon={<UxAngleDown />}
							/>
						</div>
					)}

					{isLogged ? (
						<div className='row' style={{ width: '100%' }}>
							<div className='col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3'>
								<Form
									endpoint={reviewsSection.commentEndpoint}
									className='reviews-form'
									onSuccess={() => {
										window.location.reload()
									}}
									popupErrorContent={{
										hasCloseButton: true,
										closeButtonText: strings.modalClose,
										title: strings.formPopupErrorTitle,
										content: strings.formPopupErrorContent,
										actionButtons: {
											primary: {
												text: strings.modalClose,
												closeOnClick: true
											}
										}
									}}
								>

									<Input
										id='review-content-title'
										label={strings.inputTextLabel}
										name='review-content-title'
										type='text'
										required
										size='full-width'
										errorMessages={{
											required: strings.requiredError
										}}
									/>

									<TextArea
										id='review-content-message'
										label={strings.textAreaLabel}
										name='review-content-message'
										required
										size='full-width'
										minLength={5}
										maxLength={{
											limit: 200,
											text: strings.characters
										}}
										errorMessages={{
											required: strings.requiredError,
											maxLength: strings.maxLengthError,
											minLength: strings.minLengthError
										}}
									/>

									<Input id='review-content-id' type='hidden' name='review-content-id' value={recipeId} />
									<Input id='review-date' type='hidden' name='review-date' value={dayjs().format('YYYY-MM-DDTHH:mm:ss')} />


									<Button
										type='submit'
										hover='black'
										hasBorders
										noUnderline
									>
										{strings.commentRecipeSubmit}
									</Button>
								</Form>
							</div>
						</div>
					) : (
						<Button
							href={reviewsSection.profilePageUrl}
							hover='black'
							hasBorders
							noUnderline
						>
							{strings.loginButton}
						</Button>
					)}

				</div>

			</div>
		</Section>

		<Region name={regions.region2.name} regionData={regions.region2} />

	</div>
    )
}

export default (props) => <RecipeLayout {...props} />
